import React from 'react';
import { Card } from '@/components/ui';

interface SectionCardProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  children: React.ReactNode;
  className?: string;
}

const SectionCard: React.FC<SectionCardProps> = ({ title, children, className = '', ...rest }) => (
  <Card className={`tw-mb-4 ${className}`}>
    <Card.Header>
      <h5 className="tw-mb-0 tw-text-primary">{title}</h5>
    </Card.Header>
    <Card.Body {...rest}>
      {children}
    </Card.Body>
  </Card>
);

export default SectionCard; 